import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ProgressBar from '@/components/charts/progress-bar/progress-bar';
import { SubjectModel } from '@/models/taxonomy/subject';
import { DomainModel } from '@/models/proficiency/domain';
import { LearnerVector } from '@/models/proficiency/learner-vector';
import { learnerAPI } from '@/providers/apis/learner/learner';
import moment from 'moment';
import { LEARNER_MINDSETS_VECTORS, TEMP_CONST_LEARNER, VECTOR_VALUES } from '@/utils/constants';
import { CompetencyModel } from '@/models/proficiency/competency';
import { Topic } from '@/models/proficiency/domain-topic/topic';
import { Competency } from '@/models/proficiency/domain-topic/competency';
import VectorChart from '@/routers/views/learners/learner-identity/vector-chart/vector-chart';
import JourneyListPanelComponent from '../journey-list-panel/journey-list-panel';

@Component({
  name: 'mindsets-list-panel',
  components: {
    'progress-bar': ProgressBar,
    'vector-chart': VectorChart,
    'journey-list-panel': JourneyListPanelComponent,
  },
})

export default class MindsetsListPanel extends Vue {

  @Prop()
  public subject!: SubjectModel;

  @Prop()
  private competency!: Competency;

  @Prop()
  private domain!: DomainModel;

  @Prop()
  private topic!: Topic;

  @Prop()
  private statsBucket!: string;

  @Prop()
  private userId!: string;

  @Prop()
  private month!: string;

  @Prop()
  private year!: string;

  private learnerVectors: LearnerVector[] | any = [];

  @Prop()
  private allowedVectorKeys!: string[];

  public created() {
    this.loadLearnerVectors();
  }

  public loadLearnerVectors() {
    const component = this;
    const learnerVectors: LearnerVector[] = [];
    const requestParams = component.getVectorReqParams();
    learnerAPI.fetchLearnerVectors(requestParams).then((learnerVectorPoints: LearnerVector[]) => {
      if (component.statsBucket === 'facets' && TEMP_CONST_LEARNER.indexOf(component.userId) !== -1) {
        component.learnerVectors = component.extractAllowedVectors(VECTOR_VALUES);
        return;
      }
      component.learnerVectors = component.extractAllowedVectors(learnerVectorPoints);
    });
  }

  @Watch('month')
  private onChageTimeline() {
    this.loadLearnerVectors();
  }

  @Watch('topic')
  private watchTopic() {
    this.loadLearnerVectors();
  }

  @Watch('competency')
  private watchComptency() {
    this.loadLearnerVectors();
  }

  private getVectorReqParams() {
    const component = this;
    const requestParams: any = {
      user: component.userId,
      month: Number(component.month),
      year: Number(component.year),
    };
    // console.log('component.statsBucket ', component.statsBucket , 'sub', component.subject);
    if (component.statsBucket === 'subject') {
      requestParams.subject = component.subject.code;
    } else if (component.statsBucket === 'domain') {
      requestParams.subject = component.subject.code;
      requestParams.domain = component.domain.domainCode;
    } else if (component.statsBucket === 'topic') {
      requestParams.subject = component.subject.code;
      requestParams.domain = component.domain.domainCode;
      requestParams.topic = component.topic.topicCode;
    } else if (component.statsBucket === 'competency') {
      requestParams.subject = component.subject.code;
      requestParams.domain = component.domain.domainCode;
      requestParams.topic = component.competency.topicCode;
      requestParams.competency = component.competency.competencyCode;
    }
    return requestParams;
  }

  private extractAllowedVectors(learnerVectorPoints: LearnerVector[]) {
    return this.allowedVectorKeys.map( (vectorKey: string) => {
      return learnerVectorPoints.find( (learnerVectorPoint: LearnerVector) => vectorKey === learnerVectorPoint.label);
    });
  }

}
